import React from "react";
import pageNavigationStyle from "./pageNavigationStyle";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { Link } from "react-router";
import _map from "lodash/map";
import _upperCase from "lodash/toUpper";
import { Box, List, ListItem, ListItemButton, Theme } from "@mui/material";
import Typography from "@mui/material/Typography";
import { SxProps } from "@mui/system";

type PageNavigationProps = {
  navigationLinks: Array<any>;
  headerIcon: React.ComponentType<{ sx?: SxProps<Theme> }>;
  headline: string;
  subHeadline?: string;
  tertiaryHeadline?: string;
};

const PageNavigation = ({ navigationLinks, headerIcon, headline, subHeadline, tertiaryHeadline }: PageNavigationProps) => {
  const HeaderIconComponent = headerIcon;

  return (
    <Paper elevation={4} sx={pageNavigationStyle.navigationPaper}>
      <Grid
        container
        wrap={"nowrap"}
        sx={[{
          justifyContent: "center",
          alignItems: "center"
        }, pageNavigationStyle.headlineListItem]}>
        <Grid>
          <Box sx={pageNavigationStyle.imageContainer}>
            <HeaderIconComponent sx={pageNavigationStyle.headerIcon} />
          </Box>
        </Grid>
        <Grid sx={pageNavigationStyle.headlineContainer}>
          <Typography variant={"h5"}>{headline}</Typography>
          <Box sx={pageNavigationStyle.subHeadline}>{subHeadline}</Box>
        </Grid>
      </Grid>
      <List disablePadding>
        {tertiaryHeadline && (
          <ListItem sx={pageNavigationStyle.tertiaryHeadline}>
            <Typography>{tertiaryHeadline}</Typography>
          </ListItem>
        )}
        {_map(navigationLinks, (navigationLink) => (
          <React.Fragment key={navigationLink.label}>
            <ListItem sx={pageNavigationStyle.listItem} secondaryAction={navigationLink.icon ?? null}>
              <ListItemButton component={Link} to={navigationLink.target} sx={pageNavigationStyle.navigationLink}>
                {_upperCase(navigationLink.label)}
              </ListItemButton>
            </ListItem>
          </React.Fragment>
        ))}
      </List>
    </Paper>
  );
};

export default PageNavigation;
